import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import PlatformHelper from '@sport1/react-elements/PlatformHelper'
import { ScoreType } from '../Types'

type Props = {
    type: ScoreType
    paddingBottom?: number
}

const ScoreIcon: FunctionComponent<Props> = ({ type, paddingBottom }) => {
    if (type === 'PERFECT') {
        return (
            <Grid noExpand marginX={2} paddingBottom={paddingBottom}>
                <FontelloIcon fontSize="6px" name="favorite-active" color="ORANGE" />
            </Grid>
        )
    }
    if (type === 'FAILED') {
        return (
            <Grid
                backgroundColor="RED"
                noExpand
                width={12}
                height={12}
                borderRadius="6px"
                paddingLeft={PlatformHelper.onIOS ? '0.5px' : 0}
                center
            >
                <FontelloIcon name="close-x" fontSize="6px" color="white" />
            </Grid>
        )
    }
    return null
}
export default ScoreIcon
